import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';

import { useAppCommands, useAppRuntimeState } from '../../appCore/AppRuntimeReact';
import { getReadyScreen } from '../../appCore/AppRuntime';
import ReferralsAppHello from './ReferralsAppHello';
import ReferralsAppMakeReferral from './ReferralsAppMakeReferral';
import ReferralsAppMakeRecommendation from './ReferralsAppMakeRecommendation';
import ScreenSelected from './ScreenSelected';

const ReferralsAppAuthenticated: React.FC = () => {
  const state = useAppRuntimeState();
  const commands = useAppCommands();
  const readyScreen = getReadyScreen(state.node);
  const lifecyclePrefix = 'lifecycle-debug';

  useEffect(() => {
    console.log(`[${lifecyclePrefix}] ReferralsAppAuthenticated mount`, {
      node: state.node,
      readyScreen,
    });

    return () => {
      console.log(`[${lifecyclePrefix}] ReferralsAppAuthenticated unmount`, {
        node: state.node,
        readyScreen,
      });
    };
  }, []);

  useEffect(() => {
    console.log(`[${lifecyclePrefix}] ReferralsAppAuthenticated state`, {
      node: state.node,
      readyScreen,
    });
  }, [readyScreen, state.node]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={state.node}
        style={{ width: '100%' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Container maxWidth="sm" style={{ margin: '0 auto', padding: '0' }}>
          {readyScreen === 'dashboardHome' && (
            <ReferralsAppHello
              onMakeReferral={commands.selectMakeReferral}
              onMakeRecommendation={commands.selectMakeRecommendation}
              onForceUser={commands.selectForceUser}
            />
          )}
          {readyScreen === 'makeReferral' && (
            <ScreenSelected titleText="Make a Referral" onBack={commands.selectDashboardHome}>
              <ReferralsAppMakeReferral />
            </ScreenSelected>
          )}
          {readyScreen === 'makeRecommendation' && (
            <ScreenSelected titleText="Make a Recommendation" onBack={commands.selectDashboardHome}>
              <ReferralsAppMakeRecommendation />
            </ScreenSelected>
          )}
          {readyScreen === 'forceUser' && (
            <ScreenSelected titleText="Add a user" onBack={commands.selectDashboardHome}>
              <p>force user form</p>
            </ScreenSelected>
          )}
        </Container>
      </motion.div>
    </AnimatePresence>
  );
};

export default ReferralsAppAuthenticated;
